import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import store from '@/store/index'
import routerM from './routerM';
import routerPC from './routrPC';

Vue.use(Router)

const routes = [
  {
    path:"/iframe",
    component: resolve => require(['@/components/iframe/Index'], resolve),
    children: [
      {
        path: 'dataAnalysis/teamData',
        component: resolve => require(['@/components/iframe/DataAnalysis/TeamData'], resolve),
      },
      {
        path: 'dataAnalysis/playerData',
        component: resolve => require(['@/components/iframe/DataAnalysis/PlayerData'], resolve),
      },
      {
        path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/iframe/MatchSchedule/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/iframe/MatchSchedule/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/iframe/MatchData/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframe/MatchData/MapData'], resolve)
      },
    ],
  },
  {
    path: '/judge/login',
    component: resolve => require(['@/components/judge/JudgeLogin'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
      title: '裁判登录'
    }
  },
  {
    path: '/judge',
    component: resolve => require(['@/components/judge/Index'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    children: [{
      path: 'live_manager',
      component: resolve => require(['@/components/judge/LiveManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '直播控制'
      }
    }, {
      path: 'game_manager',
      component: resolve => require(['@/components/judge/GameManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '比赛管理'
      }
    }, ],
  },
  {
    path: '/tool/create_player_banner',
    component: resolve => require(['@/components/tool/CreatePlayerBanner'], resolve)
  },

  {
    path: '/tool/realtime_odds',
    component: resolve => require(['@/components/tool/RealtimeOdds'], resolve)
  }
]

const ISMOBILE = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};
const router = new Router({
  mode: 'history',
  routes: ISMOBILE() ? routerM : routerPC,
})


router.beforeEach((to, from, next) => {
  // 检测路由配置中是否有requireLogin这个meta属性
  if (to.meta) {
    if (to.meta.title) {
      document.title = to.meta.title
    } else {
      document.title = 'PentaQ·CF'
    }

    if (to.meta.site == 'judge') {
      console.log("judge")
      //获取用户登录状态
      store.dispatch('judge/check_login')
      // store.dispatch("auth/loop_check_login") #取消定期检查登录信息
      store.dispatch("judge/loop_sync_login")
      if (to.matched.some(record => record.meta.judgeLogin)) {
        // 判断是否已登录
        if (store.getters["judge/is_login"]) {
          next()
          return
        } else {
          store.dispatch('judge/check_login').then(function(respData) {

            if (respData == true) {
              next()
            } else {
              next({
                path: "/judge/login",
                query: {
                  to_url: to.fullPath,
                  from: "route"
                }
              })
            }
          })
        }
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js